import { EDIT, SYSTEMDEFINED, PREDEFINED, NONE, INTERNATIONAL } from '../constants'
export const sectionTemplateSaveBody = (sectionTemplateFormData, file) => {
    let sectionTemplateFile = {
        sectionTemplateName: sectionTemplateFormData.sectionTemplateName,
        reportDisplayName: sectionTemplateFormData.reportDisplayName,
        keys: sectionTemplateFormData.keys,
        sectionType: sectionTemplateFormData.sectionType,
        apiKeyName : sectionTemplateFormData.apiKeyName,
        file: file,
        analystVisible: sectionTemplateFormData.analystVisible,
        
    }
    return sectionTemplateFile;
}
export const sectionTemplateEditBody = (sectionTemplateFormData, id, file) => {
    let sectionTemplateFile = {
        id: id,
        sectionTemplateName: sectionTemplateFormData.sectionTemplateName,
        reportDisplayName: sectionTemplateFormData.reportDisplayName,
        keys: sectionTemplateFormData.keys,
        sectionType: sectionTemplateFormData.sectionType,
        apiKeyName : sectionTemplateFormData.apiKeyName,
        tags : sectionTemplateFormData.tags,
        file: file,
        analystVisible: sectionTemplateFormData.analystVisible,
    }
    return sectionTemplateFile;
}
export const validateSectionTemplateForm = (sectionTemplateFormData, file) => {
    let flag = false;
    if (!sectionTemplateFormData) {
        return flag;
    }
    if (
        sectionTemplateFormData.sectionTemplateName &&
        sectionTemplateFormData.reportDisplayName &&
        sectionTemplateFormData.keys &&
        sectionTemplateFormData.sectionType && file) {
        flag = true;
    }

    return flag;
}

export const getTableFlagValue = (pageType, sectionTemplate) => {
    if (pageType !== EDIT) {
        return false
    }
    if (sectionTemplate.sectionType === SYSTEMDEFINED || sectionTemplate.sectionType === PREDEFINED || sectionTemplate.sectionDataTableType === NONE) {
        return false
    } else {
        return true
    }
}

export const setMappingData = (mappingData) => {
    let tempData = copyArray(mappingData);
    let tempMappingData = []
    tempData[0].dataMappingList.forEach(element => {
        element.elementMapping.forEach(data => {
            tempMappingData.push(
                data = {
                    ...data,
                    header: (element.header) ? element.header : '',
                    masterDataValuesNumeric: [],
                    masterDataValuesAlphaNumeric: []
                })
        })
    });
    return tempMappingData
}

export const setMasterDataValues = (mappingData, masterData) => {
    let tempData = copyArray(mappingData);
    tempData.forEach(data => {
        data.masterDataValuesNumeric = [];
        data.masterDataValuesAlphaNumeric = [];
        masterData.forEach(tempMasterData => {
            tempMasterData.value = tempMasterData.name;
            if (tempMasterData.dataType === 'NUMERIC' && data.elementDataType === 'NUMERIC') {
                data.masterDataValuesNumeric.push(tempMasterData)
            } else if (tempMasterData.dataType === 'ALPHANUMERIC' && data.elementDataType === 'ALPHANUMERIC') {
                data.masterDataValuesAlphaNumeric.push(tempMasterData)
            }
        })
    });
    return tempData
}

const checkMasterData = (mappingData, masterDataValues, selectedData) => {
    let tempData = Object.assign({}, mappingData);
    if (!selectedData) {
        tempData.masterDataKeyId = null;
        tempData.apiKeyName = null;
        return tempData
    }
    masterDataValues.forEach(data => {
        if (data.name === selectedData.name) {
            tempData.masterDataKeyId = selectedData.id
            tempData.apiKeyName = selectedData.apiKeyName
        }
    })
    return tempData
}

export const checkMasterDataKeyId = (mappingData, tableRowData) => {
    let tempData;
    if (mappingData.elementDataType === 'ALPHANUMERIC') {
        tempData = checkMasterData(mappingData, mappingData.masterDataValuesAlphaNumeric, tableRowData)
    } else {
        tempData = checkMasterData(mappingData, mappingData.masterDataValuesNumeric, tableRowData)
    }
    return tempData
}



export const setRequestMappingData = (mappingData, editData) => {
    let flag = false;
    const tempData = copyArray(mappingData);
    for (let i = 0; tempData[0].dataMappingList.length; i++) {
        for (let j = 0; j < (tempData[0].dataMappingList[i].elementMapping).length; j++) {
            if (tempData[0].dataMappingList[i].elementMapping[j].elementName === editData.elementName) {
                tempData[0].dataMappingList[i].elementMapping[j].masterDataKeyId = editData.masterDataKeyId;
                tempData[0].dataMappingList[i].elementMapping[j].apiKeyName = editData.apiKeyName;
                flag = true
                break;
            }
        }
        if (flag) {
            break;
        }
        /* tempData[0].dataMappingList[0].elementMapping.forEach(element => {
            if (element.elementName === editData.elementName) {
                element.masterDataKeyId = editData.masterDataKeyId
            }
        }) */
    }
    return tempData
}

export const checkSectionTemplateFetchData = (sectionTemplateData) => {
    if (sectionTemplateData.sectionType === PREDEFINED || sectionTemplateData.sectionType === SYSTEMDEFINED || sectionTemplateData.sectionDataTableType === NONE) {
        return false
    } else {
        return true
    }
}
export const setMasterDataKey = (rowName, rowData, data) => {
    let tempData;
    rowData.forEach(elementData => {
        if (elementData.elementName === rowName) {
            tempData = Object.assign({}, elementData);
        }
    })
    tempData.masterDataKeyId = (data) ? data.id : null
    tempData.apiKeyName = (data) ? data.apiKey : null
    return tempData
}
export const copyArray = (data) => {
    let tempLevelOne = JSON.stringify(data);
    return JSON.parse(tempLevelOne)
}


export const updateMappingData = (mappingData, rowData) => {
    let temp = [];
    mappingData.map(obj => {
        if(obj.elementName == rowData.elementName){
            obj.apiKeyName = rowData.apiKeyName;
            obj.masterDataKeyId = rowData.masterDataKeyId;
        }
        temp.push(obj)
    })
    return temp;
}